import { FormGroup } from '@angular/forms';

export class FormValue {

    static get(form: FormGroup, includeDisabledFields?: boolean) {
        let request = form.value || {};

        if (includeDisabledFields) {
            for (const [field, formControl] of Object.entries(form.controls)) {
                request[field] = typeof formControl.value === 'string' ? formControl.value?.trim() : formControl.value;
            }
        }
        else {
          for (const [field, formControl] of Object.entries(form.controls)) {
            if (typeof formControl.value === 'string') {
              request[field] = formControl.value?.trim() || '';
            }
          }
        }

        return request;
    }

}
